import React, { useEffect } from 'react';
import HeaderV2 from '../../components/v2/HeaderV2';
import FooterV2 from '../../components/v2/FooterV2';
import ContactHeroV2 from '../../components/v2/ContactHeroV2';
import ContactFormV2 from '../../components/v2/ContactFormV2';
import useV2Language from '../../hooks/useV2Language';
import useDocumentLanguage from '../../hooks/useDocumentLanguage';
import '../../styles/v2/tokens.css';
import '../../styles/v2/landing.css';
import '../../styles/v2/audit.css';
import '../../styles/v2/contact.css';

const PAGE_TITLES = { en: 'Contact — illumi.dev', es: 'Contacto — illumi.dev' };

const ContactV2 = () => {
  const { lang, setLang, buildHref } = useV2Language();
  useDocumentLanguage(lang);
  useEffect(() => { document.title = PAGE_TITLES[lang] || PAGE_TITLES.en; }, [lang]);
  return (
    <div className="illumi-v2" data-testid="illumi-v2-contact">
      <HeaderV2 language={lang} onLanguageChange={setLang} buildHref={buildHref} />
      <main>
        <ContactHeroV2 lang={lang} />
        <section className="iv2-contact-form-section">
          <div className="iv2-container iv2-contact-form-container">
            <ContactFormV2 lang={lang} />
          </div>
        </section>
      </main>
      <FooterV2 language={lang} buildHref={buildHref} />
    </div>
  );
};
export default ContactV2;
